__turbopack_context__.v({
  "from": "LeasingPrice-module__9XFq3a__from",
  "initialRentalText": "LeasingPrice-module__9XFq3a__initialRentalText",
  "leasingPriceBlock": "LeasingPrice-module__9XFq3a__leasingPriceBlock",
  "monthlyPrice": "LeasingPrice-module__9XFq3a__monthlyPrice",
  "priceContent": "LeasingPrice-module__9XFq3a__priceContent",
});
